<div class="bg_clr">
  <div class="login_box">
    <div class="login_box_content">
      <div class="login-wrapper-bg">
        <div class="logo">
          <div class="logo-img">
            <img src="../../../assets/images/login-logo.svg" class="img-responsive" alt="WOW" />
            <p>Ways of Working</p>
          </div>
        </div>
        <div class="login_content">
          <div class="login_form">
            <!-- <h3>Login</h3> -->
            <form action="" autocomplete="off" #loginForm="ngForm" (submit)="onSubmit()" novalidate=''>
              <div class="form-group">
                <mat-form-field class="block-input">
                  <img class="prefix-icon" width="16px" src="assets/images/user-icon.svg" matPrefix/>
                  <input matInput type="text" name="username" [(ngModel)]="login.userid" #loginUserId="ngModel"
                    placeholder="Username" minlength="3" maxlength="25" autocomplete="off" required/>
                  <mat-error *ngIf="loginUserId.errors &&  loginUserId.touched">
                    <mat-hint [hidden]="!loginUserId.errors.required">Username is required</mat-hint>
                    <mat-hint [hidden]="!loginUserId.errors.minlength">Username must be 3 characters</mat-hint>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field class="block-input">
                    <img class="prefix-icon" width="15px" src="assets/images/pwd-lock.svg" matPrefix/>
                  <input matInput id="loginPsw" [type]="showPassword ? 'text' : 'password'" name="password" [(ngModel)]="login.password" minlength="3"
                    #loginPsw="ngModel" placeholder="Password" autocomplete="off" required/>
                  <img class="suffix-icon" matSuffix *ngIf="showPassword" src="assets/images/show-pwd.svg" (click)="toggleInputType()">
                  <img class="suffix-icon" matSuffix *ngIf="!showPassword" src="assets/images/hide-pwd@3x.png" (click)="toggleInputType()">
                  <mat-error *ngIf="loginPsw.errors && loginPsw.touched">
                    <mat-hint [hidden]="!loginPsw.errors.required">Password is required</mat-hint>
                    <mat-hint [hidden]="!loginPsw.errors.minlength">Password must be atleast 5 characters</mat-hint>
                  </mat-error>
                </mat-form-field>
                <!-- <img src="../../../assets/images/view.svg" alt="Show Password" class="pwd-toggle" (click)="togglePwd()" /> -->
              </div>
              <div class="form-actions">
                <button class="login-button" [disabled]="!loginForm.valid">Login</button>
              </div>
            </form>
            <p class="padding_top"><a href="javascript:void(0)" routerLink="/forgotpassword" class="forgot_psw"> Forgot
                password ?</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>